module.exports = __webpack_public_path__ + "img/20190629102858QQ截图20190624162227.091df4b7.png";